import { type Icon, type Menu, type MenuItem, type WithId } from '../typings'

export const data: {
  main: Array<(Menu<Icon> & WithId) | MenuItem>
  category: Array<Menu>
} = {
  main: [
    {
      title: 'Ofertas',
      path: 'https://www.holidayguru.es/deals/',
    },
    {
      title: 'Destinos',
      path: 'https://www.holidayguru.es/destinos/',
    },
    {
      title: 'Última hora',
      path: 'https://www.holidayguru.es/ofertas-ultimo-minuto/',
    },
    {
      title: 'Todo Incluido',
      path: 'https://www.holidayguru.es/ofertas-todo-incluido/',
    },
  ],
  category: [
    {
      title: 'Alojamientos',
      children: [
        {
          path: 'https://www.holidayguru.es/hoteles/',
          title: 'Hoteles',
        },
        {
          path: 'https://www.holidayguru.es/escapadas-rurales/',
          title: 'Escapadas rurales',
        },
        {
          path: 'https://www.holidayguru.es/hoteles-con-banera-hidromasaje/',
          title: 'Hoteles con bañera hidromasaje',
        },
        {
          path: 'https://www.holidayguru.es/viajes-de-lujo/',
          title: 'Lujo',
        },
      ],
    },
    {
      title: 'Escapadas',
      children: [
        {
          path: 'https://www.holidayguru.es/vuelos-y-hotel/',
          title: 'Vuelos y hotel',
        },
        {
          path: 'https://www.holidayguru.es/escapadas-fin-de-semana/',
          title: 'Fin de semana',
        },
        {
          path: 'https://www.holidayguru.es/escapada-romantica/',
          title: 'Escapadas románticas',
        },
        {
          path: 'https://www.holidayguru.es/circuitos/',
          title: 'Circuitos',
        },
        {
          path: 'https://www.holidayguru.es/vacaciones-con-ninos/',
          title: 'Vacaciones con niños',
        },
        {
          path: 'https://www.holidayguru.es/ofertas-spa/',
          title: 'Spa',
        },
      ],
    },
    {
      title: 'Destinos',
      children: [
        {
          path: 'https://www.holidayguru.es/destinos/espana/',
          title: 'Viajes por España',
        },
        {
          path: 'https://www.holidayguru.es/destinos/baleares/',
          title: 'Viajes a Islas Baleares',
        },
        {
          path: 'https://www.holidayguru.es/destinos/canarias/',
          title: 'Viajes a Islas Canarias',
        },
        {
          path: 'https://www.holidayguru.es/destinos/cerdena/',
          title: 'Viajes a Cerdeña',
        },
        {
          path: 'https://www.holidayguru.es/destinos/tenerife/',
          title: 'Viajes a Tenerife',
        },
        {
          path: 'https://www.holidayguru.es/destinos/andalucia/',
          title: 'Viajes a Andalucía',
        },
        {
          path: 'https://www.holidayguru.es/destinos/islas-griegas/',
          title: 'Viajes a las Islas Griegas',
        },
        {
          path: 'https://www.holidayguru.es/destinos/portugal/',
          title: 'Viajes a Portugal',
        },
        {
          path: 'https://www.holidayguru.es/destinos/',
          title: 'Todos los destinos',
        },
      ],
    },
    {
      title: 'Ofertas Especiales ',
      children: [
        {
          path: 'https://www.holidayguru.es/calendario-de-viajes/',
          title: 'Calendario de Viajes',
        },
        {
          path: 'https://www.holidayguru.es/calendario-de-viajes/mejor-epoca-para-viajar-a-los-mejores-destinos/',
          title: 'Mejor época para viajar',
        },
        {
          path: 'https://www.holidayguru.es/semana-santa/',
          title: 'Semana Santa',
        },
        {
          path: 'https://www.holidayguru.es/vacaciones-verano/',
          title: 'Vacaciones Verano',
        },
        {
          path: 'https://www.holidayguru.es/calendario-de-viajes/mercados-navidenos/',
          title: 'Mercadillos navideños',
        },
        {
          path: 'https://www.holidayguru.es/puente-de-diciembre/',
          title: 'Puente de diciembre',
        },
        {
          path: 'https://www.holidayguru.es/calendario-de-viajes/nochevieja/',
          title: 'Nochevieja',
        },
      ],
    },
  ],
}
